// @flow

import styles from './ButtonContent.scss';

type Props = {
  children: React.Node,
  addon: string,
};

export function ButtonContent({ children, addon }: Props): React.MixedElement {
  return (
    <span className="Button-label">
      <span className={styles.root}>
        <span>{children}</span>
        <span>{addon}</span>
      </span>
    </span>
  );
}
